import { Language } from '../../language/English';
import { API_WEBSITE_LOGOUT_URL } from '../../pages/Login/Api/loginConstants';
import { LoginService } from '../../pages/Login/Api/LoginService';
import { PAGE_LOGIN } from '../../PagesNames';
import Logger from '../Logger/Logger';
import Notification from '../Notification/Notification';
import WebsiteHttpService from '../WebsiteHttp/WebsiteHttpService';

export const callLogoutApi = async (
    dispatch: any,
    logoutAction: () => any,
    navigate: (url: string) => void,
) => {
    const notification = new Notification();
    const logger = new Logger();
    const websiteService = new WebsiteHttpService();
    const loginService = new LoginService();

    try {
        const response = await websiteService.get(API_WEBSITE_LOGOUT_URL, {});
        if (response && response.isRequestSuccessful) {
            try {
                const response = await loginService.get();
                if (response && response.isSuccess) {
                    dispatch(logoutAction());
                    navigate(PAGE_LOGIN);
                } else {
                    notification.error(Language.SOMETHING_IS_WRONG);
                }
            } catch (e) {
                notification.error(Language.SOMETHING_IS_WRONG);
                logger.error(e);
            }
        } else {
            notification.error(Language.SOMETHING_IS_WRONG);
        }
    } catch (e) {
        notification.error(Language.SOMETHING_IS_WRONG);
        logger.error(e);
    }
};
